import "./validate.env";

const env = Object.freeze({
  APP_TITLE: process.env.REACT_APP_TITLE ?? "Banquet First",
  APP_SUB_TITLE: process.env.REACT_APP_SUB_TITLE ?? "Spaces Smarter with Banquet First",
  APP_VARIANT: process.env.REACT_APP_VARIANT!,

  SERVER_BASE_URL: process.env.REACT_APP_SERVER_URL!,
  FOOD_APP_URL: process.env.REACT_APP_FOOD_APP_URL!,

  GOOGLE_MAP_API_KEY: process.env.REACT_APP_GOOGLE_MAP_API_KEY!,

  LOGIN_AS_USER_URL: process.env.REACT_APP_OTHER_USER_ACCESS_DOMAIN!,

  IMAGE_BASE_URL: process.env.REACT_APP_IMAGE_BASE_URL!,
  S3_BASE_URL: process.env.REACT_APP_S3_BASE_URL!,
  S3_WHATSAPP_BASE_URL:
    process.env.REACT_APP_WHATSAPP_S3_URL ||
    process.env.REACT_APP_S3_BASE_URL ||
    "",
  DOC_PREVIEW_URL: process.env.REACT_APP_EXCEL_VIEW_URL_PREFIX!,

  S3_ENR_BOILERPLATE_URL: process.env.REACT_APP_S3_ENR_BIOLERPLATE_URL!,

  IS_SOCKET_ENABLED: process.env.REACT_APP_ENABLE_SOCKET === "true",

  HIDE_VENUE_CREATE: process.env.REACT_APP_HIDE_VENUE_CREATE === "true",

  GENERAL_LEADS_AUTH_KEY:  process.env.REACT_APP_GENERAL_LEADS_AUTH_KEY!,

  GENERAL_LEADS_SOURCE_COMPANY_NAME:  process.env.REACT_APP_GENERAL_LEADS_SOURCE_COMPANY_NAME!,
});

export default env;